export function hasLinks(text) {
  return !!(text && /(https?:\/\/|www\.)/i.test(text));
}

export function LinkTokens({ text }) {
  if (!text) return null;
  const parts = text.split(/(\s+)/);
  return parts.map((tok, i) => {
    const isHttp = /^https?:\/\/\S+$/i.test(tok);
    const isWww = /^www\.\S+$/i.test(tok);
    if (isHttp || isWww) {
      const href = isHttp ? tok : `https://${tok}`;
      return (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="text-fuchsia-300 hover:text-fuchsia-200 underline break-all"
        >
          {tok}
        </a>
      );
    }
    return <span key={i}>{tok}</span>;
  });
}

export function LinkifiedText({ text, testId }) {
  if (!text) return null;
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-white/5 bg-white/[0.02] p-3 text-sm text-zinc-300 leading-relaxed whitespace-pre-wrap break-words"
    >
      <LinkTokens text={text} />
    </div>
  );
}
